var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 49,
    viewBox: "0 0 61 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68415 19.0143L2.34208 21.3698L0 19.0143L2.34208 16.6587L4.68415 19.0143ZM61 45.6683C61 46.5519 60.651 47.3993 60.0297 48.0242C59.4085 48.649 58.5659 49 57.6873 49C56.8087 49 55.9661 48.649 55.3449 48.0242C54.7236 47.3993 54.3746 46.5519 54.3746 45.6683H61ZM18.9056 38.0286L2.34208 21.3698L7.02623 16.6587L23.5897 33.3175L18.9056 38.0286ZM2.34208 16.6587L18.9056 0L23.5897 4.71109L7.02623 21.3698L2.34208 16.6587ZM4.68415 15.6825H37.8111V22.346H4.68415V15.6825ZM61 39.0048V45.6683H54.3746V39.0048H61ZM37.8111 15.6825C43.9612 15.6825 49.8594 18.1397 54.2081 22.5135C58.5569 26.8872 61 32.8193 61 39.0048H54.3746C54.3746 34.5866 52.6295 30.3494 49.5233 27.2253C46.417 24.1011 42.204 22.346 37.8111 22.346V15.6825Z",
    fill: "#224366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackIcon);
export default __webpack_public_path__ + "static/media/arrow-back-icon.1b0501a234c3356f07b7577f79835608.svg";
export { ForwardRef as ReactComponent };